import '../assets/scss/index.scss'

import { Box, useMediaQuery } from '@mui/material'
import { useTheme } from '@mui/material/styles'
import React, { useEffect } from 'react'
import type { IUserProfile } from '../redux/api/types'
import { useSelector } from 'react-redux'
import { SHA256, enc } from 'crypto-js'
import { PATH } from '../routes/constant'
import { useNavigate } from 'react-router-dom'
import { isLocalPresenceCountry } from '../utils/isLocalPresenceCountry'

const generateYextDashboardUrl = () => {
  // Collect the required params.
  const user: IUserProfile = useSelector((state: any) => state.userState.user)
  const timestamp = Math.floor(new Date().getTime() / 1000)
  const accountId = process.env.REACT_APP_YEXT_ACCOUNT as string
  const secret = process.env.REACT_APP_YEXT_SECRET_KEY as string
  // Generate SHA-256 hash.
  const value: string = `${accountId}|${user.yextUserId}|${timestamp}|${secret}`
  const sign: string = SHA256(value).toString(enc.Hex)
  const YEXT_BASE_URL: string = process.env.REACT_APP_YEXT_URL as string

  return `${YEXT_BASE_URL}users/corplogin?accountid=${accountId}&code=${user.yextUserId}&timestamp=${timestamp}&sign=${sign}&useSha256=true&embed=1&nav=listingsOverview`
}

const LocalPresencePage: React.FC = () => {
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('lg'))
  const navigate = useNavigate()
  const user: IUserProfile = useSelector((state: any) => state.userState.user)
  const isLocalPresence: boolean = user.permissions.localPresence && user.yextUserId !== null && user.yextUserId !== '' && isLocalPresenceCountry(user) && !user.isPaymentPastDue

  useEffect(() => {
    if (!isLocalPresence) {
      navigate(PATH.HOME, { replace: true })
    }
  }, [])

  return (
    <Box sx={{ mx: isMobile ? 3 : 5, my: 3, height: '100%', display: 'flex', justifyContent: 'center' }}>
      <iframe src={generateYextDashboardUrl()} width="100%" height="100%" title="YEXT dashboard" />
    </Box>
  )
}

export default LocalPresencePage
